"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function Footer() {
  const pathname = usePathname();
  const isDashboard = pathname.includes("/dashboard") || pathname.includes("/bank");
  const isAuth = pathname.includes("/auth");

  if (isDashboard || isAuth) return null;

  return (
    <footer className={`border-t bg-black text-white`}>
      <div className="md:container mx-auto px-4 md:px-0 lg:w-[85%] py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-gray-600">
          {/* Copyright */}
          <p className="text-center md:text-start">
            © {new Date().getFullYear()}{" "}
            <span className="font-semibold text-gray-800">Sana</span>. All
            rights reserved.
          </p>

          {/* Powered by */}
          <div className="flex rtl:flex-row-reverse items-center justify-center md:justify-end">
            <span className="mr-1">Powered by</span>
            <Link
              href="https://yousef-abdallah.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-gray-800 hover:text-primary transition"
            >
              <Image
                src={`/symbol.png`}
                alt="Sana Logo"
                width={20}
                height={20}
                className="inline-block ml-1"
              />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
